import React, { useEffect, useState } from "react";
import { Outlet } from "react-router-dom";
import { useAuth } from "../auth/AuthContext";
import Layout from "./Layout";
import SubscriptionRequiredPage from "../pages/SubscriptionRequiredPage";

export default function RequireXTranslator() {
  const { xTranslatorAccess, xTranslator, refreshAccess } = useAuth();
  const [checking, setChecking] = useState(!xTranslator);

  useEffect(() => {
    let cancelled = false;
    Promise.resolve(refreshAccess()).finally(() => {
      if (!cancelled) setChecking(false);
    });
    return () => {
      cancelled = true;
    };
  }, [refreshAccess]);

  if (checking && !xTranslator) {
    return (
      <Layout>
        <p className="text-gray-500">Checking your X-Translator subscription…</p>
      </Layout>
    );
  }
  if (!xTranslatorAccess) {
    return (
      <Layout>
        <SubscriptionRequiredPage />
      </Layout>
    );
  }
  return <Outlet />;
}
